import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import styles from './LineChart.styles';
import { ResponsiveLine } from '@nivo/line';

const LineChart = props => {
  const { classes, kpiData, chartProps, ...rest } = props;
  // console.log(kpiData)
  return <ResponsiveLine {...chartProps} data={kpiData} {...rest} />;
};

LineChart.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles)(LineChart);
